import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchConfig = async () => {
  const { data } = await api.get("/config");
  return data;
};

export const submitLead = async (payload) => {
  const { data } = await api.post("/leads", payload);
  return data;
};

export const buildKonfiguratorSrc = (k) => {
  if (!k || !k.base_url) return "";
  const params = new URLSearchParams({
    license_key: k.license_key || "",
    text_color: k.text_color || "#ffffff",
    accent_color: k.accent_color || "#fbff00",
    pulse_color: k.pulse_color || "#fff700",
    pulse_enabled: String(k.pulse_enabled),
    dyno_enabled: String(k.dyno_enabled),
  });
  return `${k.base_url}/?${params.toString()}`;
};
